import { post, get } from '@/axios/method';

/**
 * 提交登记表单
 * 易聪林 http://yapi.dev.anoah.com/project/1225/interface/api/59613
 * @param {*} data 
 * @returns 
 */
export const submitForm = (data) => post('/api/dm/market/spread/plan/commonSpreadFormApply', data);

/**
 * 查询渠道详情
 * 吴冲 http://yapi.dev.anoah.com/project/1242/interface/api/56728
 * @param {*} data 
 * @returns 
 */
export const getChannelDetail = (data) => post('/api/dm/market/spread/getChannelById', data);

/**
 * 根据参数换取小程序地址
 * 凃铭鉴 http://yapi.dev.anoah.com/project/1242/interface/api/56728
 * @param {*} data 
 * @returns 
 */
export const getMiniUrl = (data) => post('/api/dm/market/shortCode/createMiddenPageShortUrl', data);

/**
 * 根据参数获取导购信息
 * 易聪林 
 * @param {*} data 
 * @returns 
 */
export const getGuideInfo = (data) => post('/api/dm/clue/spread/getRecommendUserInfo', data);